import { FunctionComponent, memo } from 'react';
import _ from 'lodash';
import { Case, Item as ItemType, Odd as OddType } from '~types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Item from './Item';
import './itemStyles.scss';

interface Props {
  getItems: ItemType[];
  getOdd: OddType;
}

const Items: FunctionComponent<Props> = memo(({ getItems, getOdd }) => {
  return (
    <>
      {_.map(getItems, (getItem) => (
        <Item key={getItem.id} getItem={getItem} getOdd={getOdd} />
      ))}
    </>
  );
});

interface IItemsView {
  getCase: Case;
}

const ItemsView: FunctionComponent<IItemsView> = memo(({ getCase }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="case_contains">
        <div className="case_contains_title">
          <h2>{t('Case Contains')}</h2>
        </div>
        <div className="case_contains_items">
          <Items getItems={getCase?.getItems} getOdd={getCase?.getOdd} />
        </div>
      </div>
      {/* <br />
      <br />
      <div className="in-case">
        <div className="in-case-title title-fair-play">
          <span className="name">{t('Case Contains')}</span>
          <Link to={`${getCase?.getUrl}/odds`}>
            <button className="btn-drop-chance" data-rar={getCase?.color}>
              {t('Drop_chances')}
            </button>
          </Link>
        </div>
        <div className="case_contains_items">
          <Items getItems={getCase?.getItems} getOdd={getCase?.getOdd} />
        </div>
      </div> */}
    </>
  );
});

export { ItemsView };
